import React from "react";
import { useState } from "react";
// import "react-datepicker/dist/react-datepicker.css";
import { Col, Row } from "reactstrap";
import Button from "../../../../../components/Button";
import TextArea from "../../../../../components/textArea/TextArea";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FinetuneIconFb from "./previewSetting/FinetuneIconFb";
import DateTimePicker from "react-datetime-picker";
import dummyimg from "../../../../../assets/img/dummyimg.png";

const FineTuneFacebook = ({
  socialchannel,
  setOpenModal,
  activeTab,
  setActiveTab,
  postDate,
  caption,
  facebookData,
  images,
  selectedAccountSocials,
}) => {
  const [facebookStartDate, setFacebookStartDate] = useState(postDate);
  const [facebookCaption, setFacebookCaption] = useState(caption);
  const [count, setCount] = useState(2200);

  const onChangeTextArea = (e) => {
    const value = e.target.value;
    const valueLength = e.target.value.length;
    setFacebookCaption(value);
    setCount(2200 - valueLength);
  };

  const nextButton = (tab) => {
    if (socialchannel.length === activeTab) {
      facebookData(facebookCaption, facebookStartDate);
      setOpenModal(true);
    } else {
      if (activeTab !== tab) {
        facebookData(facebookCaption, facebookStartDate);
        setActiveTab(tab);
      }
    }
  };

  return (
    <div className="finetuneTabContent">
      <Row>
        <Col xs="12" md="7" sm="12">
          <div className="previewWrapper">
            <h2> Preview</h2>
            <div className="preview-fb-wrapper">
              <div className="preview-dp-wrapper mb-3">
                <div className="dp">
                  <img
                    src={
                      selectedAccountSocials?.facebook?.profile_image ||
                      dummyimg
                    }
                    alt="dp"
                  />
                </div>
                <div>
                  {selectedAccountSocials?.facebook?.username ? (
                    <span>{selectedAccountSocials?.facebook?.username}</span>
                  ) : null}
                </div>
              </div>
              <div>
                <p
                  className="previewText"
                  dangerouslySetInnerHTML={{
                    __html: JSON.stringify(facebookCaption)
                      .replace(/\\n/g, "<br>")
                      ?.replaceAll('"', ""),
                  }}
                />
              </div>
              <div>
                <Carousel showThumbs={false} infiniteLoop={true} autoPlay>
                  {images?.map((image, index) => {
                    return (
                      <div className="img-holder" key={index}>
                        {image?.type.slice(0, 5) === "video" ? (
                          <video width="100%" height="100%" controls autoplay>
                            <source
                              src={URL.createObjectURL(image)}
                              type={`video/${image?.name.slice(-3)}`}
                            />
                          </video>
                        ) : (
                          <img src={URL.createObjectURL(image)} alt="" />
                        )}
                      </div>
                    );
                  })}
                </Carousel>
              </div>
              <FinetuneIconFb />
            </div>
          </div>
        </Col>
        <Col xs="12" md="5" sm="12">
          <div>
            <DateTimePicker
              dayPlaceholder="dd"
              monthPlaceholder="mm"
              yearPlaceholder="yy"
              hourPlaceholder="hh"
              minutePlaceholder="mm"
              onChange={(value) => setFacebookStartDate(value)}
              value={facebookStartDate}
              clearIcon={null}
              calendarIcon={null}
              disableClock={true}
              minDate={new Date()}
              className="scheduleDateInput"
            />
            <br />
            <br />
            <TextArea
              maxLength="2200"
              placeholder="Caption"
              value={facebookCaption}
              onChangeTextArea={onChangeTextArea}
              count={count}
            />
            <Button
              text="Next"
              onButtonClick={() => nextButton(activeTab + 1)}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FineTuneFacebook;
